import { Icon } from "@vds/icons";
import { Loader } from "@vds/loaders";
import { Modal, ModalBody } from "@vds/modals";
import { Body } from "@vds/typography";
import { useState } from "react";
import styled from "styled-components";
import { formattedTimeStamp } from "../../../utils";
import "../../../styles/cameraSnapshot.css";

const BIContent = styled.div`
        display: grid;
        grid-template-columns: auto 1fr;
        align-items: start;
        gap: 4px;
        width: 100%;
        `;

    const LightText = styled.div`
        color: #6f7171;
        font-feature-settings: "clig" off, "liga" off;
        /* [VDS] DeskTab/🖥 Body LG */
        font-family: "Verizon-NHG-eDS";
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px;
        letter-spacing: 0.5px;
        `;

export const TableSnapshot = ({loading, snapshotImage, timeStamp, cameraName, streamName, refetchImage}) => {
    const [openModal, setOpenModal] = useState(false);

    return loading ? (
        <div className="camera-snapshot-loading">
            <div className="camera-snapshot-loader-wrapper">
                <Loader active={true} fullscreen={false} surface="light" />
            </div>
        </div>
    ) : (
        <>
        <div>
            <div className="camera-snapshot-table-container">
            {" "}
            {snapshotImage ? (
                <img
                src={snapshotImage}
                alt="Stream Snapshot"
                className="camera-snapshot-table"
                data-testid="devices_cameraZoomSnapshot" 
                onClick={() => {
                    setOpenModal(true);
                }}
                />
            ) : (
                <div className="camera-snapshot-error"> 
                    <div className="camera-snapshot-error-content">
                        <Icon name="error" size="small" color="#6f7171" />
                        <LightText>Snapshot failed to load</LightText>
                    </div>
                </div>
            )}
            <div
                className="camera-snapshot-refresh-btn"
                data-testid="devices_cameraRefreshSnapshot" 
                onClick={() => refetchImage()}
            >
                <Icon name="sync" size="small" color="#000000" />
            </div>
            </div>
            <Modal
            opened={openModal}
            onOpenedChange={(opened) => {
                if (!opened) {
                    setOpenModal(false);
                }
            }}
            hideCloseButton={true}
            style={{ overflow: "hidden" }}
            closeButton={
                <div
                style={{
                    cursor: "pointer",
                    position: "absolute",
                    right: "25px",
                    top: "25px",
                }}
                data-testid="devices_cameraZoomSnapshotModalCloseButton" 
                onClick={() => setOpenModal(false)}
                >
                <Icon name="close" />
                </div>
            }
            >
            <ModalBody>
                <img
                src={snapshotImage}
                alt="floorImage"
                className="camera-snapshot-modal"
                />
                <div style={{ marginTop: "15px" }}>
                <Body size="large">
                    {cameraName},{" "}{streamName}
                </Body>
                </div>
            </ModalBody>
            </Modal>
        </div>
        <div>
            <BIContent>
            {timeStamp && (() => {
                const formatted = formattedTimeStamp(timeStamp);
                return (
                    <LightText>
                        Updated:{" "}
                        <div>{formatted.time}</div>
                        <div>{formatted.date}</div>
                    </LightText>
                );
            })()}
            </BIContent>
        </div>
        </>
    );
}